import {
  Create,
  SimpleForm,
  TextInput,
  PasswordInput,
  ReferenceArrayInput,
  SelectArrayInput
} from 'react-admin';
import {
  hasValue,
  email
} from "../../utils/schemas";
import * as Yup from "yup";
import { Grid } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import CustomSaveToolbar from "../../ui/custom-save-toolbar";

const Schema = Yup.object(
{
  name: hasValue(),
  email: email(),
  password: hasValue()
});

const AdminCreate = () =>
{
  return (
    <Create
      title="Novo Usuário Admin"
      redirect="list">
      <SimpleForm
        noValidate
        resolver={yupResolver(Schema)}
        toolbar={ <CustomSaveToolbar /> }>
        <Grid container columnSpacing={2} width="100%">
          <Grid size={{ xs: 6 }}>
            <TextInput source="name" label="Nome" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 3 }}>
            <TextInput source="email" label="E-mail" type="email" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 3 }}>
            <PasswordInput source="password" label="Senha" fullWidth isRequired />
          </Grid>
          <Grid size={{ xs: 6 }} />

          <Grid size={{ xs: 6 }}>
            <ReferenceArrayInput source="permissions" sort={{ field: 'name', order: 'ASC' }} reference="setup/permissions" >
              <SelectArrayInput label="Permissão(ões)" optionText="name" optionValue="id" fullWidth />
            </ReferenceArrayInput>
          </Grid>
          <Grid size={{ xs: 6 }} />
        </Grid>
      </SimpleForm>
    </Create>
  )
}

export default AdminCreate;
